import React from "react";

const AdminDashboard = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminDashboard").then((m) => ({
    default: m.AdminDashboard,
  })),
);
const AdminUserManagement = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminUserManagement").then((m) => ({
    default: m.AdminUserManagement,
  })),
);
const AdminUserProfilePage = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminUserProfilePage").then((m) => ({
    default: m.AdminUserProfilePage,
  })),
);
const AdminProjects = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminProjects").then((m) => ({
    default: m.AdminProjects,
  })),
);
const AdminProposals = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminProposals").then((m) => ({
    default: m.AdminProposals,
  })),
);
const AdminMilestones = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminMilestones").then((m) => ({
    default: m.AdminMilestones,
  })),
);
const AdminServices = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminServices").then((m) => ({
    default: m.AdminServices,
  })),
);
const AdminJobListings = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminJobListings").then((m) => ({
    default: m.AdminJobListings,
  })),
);
const AdminFinance = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminFinance").then((m) => ({
    default: m.AdminFinance,
  })),
);
const AdminSubscribers = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminSubscribers"),
);
const AdminSkillsPage = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminSkillsPage").then((m) => ({
    default: m.AdminSkillsPage,
  })),
);
const AdminContent = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminContent").then((m) => ({
    default: m.AdminContent,
  })),
);
const AdminCourses = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminCourses").then((m) => ({
    default: m.AdminCourses,
  })),
);
const AdminMessages = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminMessages").then((m) => ({
    default: m.AdminMessages,
  })),
);
const AdminAnnouncements = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminAnnouncements").then((m) => ({
    default: m.AdminAnnouncements,
  })),
);
const AdminSettings = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminSettings").then((m) => ({
    default: m.AdminSettings,
  })),
);
const AdminAnalytics = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminAnalytics").then((m) => ({
    default: m.AdminAnalytics,
  })),
);
const AdminDisputes = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminDisputes").then((m) => ({
    default: m.AdminDisputes,
  })),
);

const AdminAuditLog = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminAuditLog").then((m) => ({
    default: m.AdminAuditLog,
  })),
);
const AdminCoupons = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminCoupons").then((m) => ({
    default: m.AdminCoupons,
  })),
);

const AdminBlogs = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminBlogs").then((m) => ({
    default: m.AdminBlogs,
  })),
);
const AdminBlogEditor = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminBlogEditor").then((m) => ({
    default: m.AdminBlogEditor,
  })),
);
const AdminBlogPreview = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminBlogPreview"),
);
const AdminMatching = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminMatching").then((m) => ({
    default: m.AdminMatching,
  })),
);

const AdminVerification = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminVerification").then((m) => ({
    default: m.AdminVerification,
  })),
);

const AdminReviews = React.lazy(() =>
  import("../components/pages/admin-dashboard/AdminReviews").then((m) => ({
    default: m.AdminReviews,
  })),
);

export const ADMIN_ROUTES = [
  { path: "/admin", element: AdminDashboard },
  { path: "/admin/users", element: AdminUserManagement },
  { path: "/admin/users/:id", element: AdminUserProfilePage },
  { path: "/admin/projects", element: AdminProjects },
  { path: "/admin/proposals", element: AdminProposals },
  { path: "/admin/milestones", element: AdminMilestones },
  { path: "/admin/services", element: AdminServices },
  { path: "/admin/jobs", element: AdminJobListings },
  { path: "/admin/finance", element: AdminFinance },
  { path: "/admin/subscribers", element: AdminSubscribers },
  { path: "/admin/skills", element: AdminSkillsPage },
  { path: "/admin/content", element: AdminContent },
  { path: "/admin/courses", element: AdminCourses },
  { path: "/admin/messages", element: AdminMessages },
  { path: "/admin/disputes", element: AdminDisputes },
  { path: "/admin/announcements", element: AdminAnnouncements },
  { path: "/admin/settings", element: AdminSettings },
  { path: "/admin/analytics", element: AdminAnalytics },
  { path: "/admin/audit", element: AdminAuditLog },
  { path: "/admin/coupons", element: AdminCoupons },
  { path: "/admin/blogs", element: AdminBlogs },
  { path: "/admin/blogs/new", element: AdminBlogEditor },
  { path: "/admin/blogs/:id/edit", element: AdminBlogEditor },
  { path: "/admin/blogs/:id/preview", element: AdminBlogPreview },
  { path: "/admin/matching", element: AdminMatching },
  { path: "/admin/verification", element: AdminVerification },
  { path: "/admin/reviews", element: AdminReviews },
];
